export default __webpack_public_path__ + "static/media/2.8505a478.png";